import { BellElectric, BotMessageSquare, CheckCheck, ChevronLeft, ChevronRight, CornerDownRight, LayoutGrid, ListChecks, Minus, MoveLeft, MoveRight, Pencil, Play, Plus, StepBack, StepForward, X } from "lucide-react";
import React, { useEffect, useState,useRef } from "react";
import fallback_img from "../img/fallback_img.jpg"
import loading_img from "../img/loadingImg.jpg"
import ScrollTransformWrapper from "../../DesignElements/hook/ScrollTransformWrapper";
import YoutubeVideoPlayerWebUI from "../../../../UI/YoutubeVideoPlayerWebUI";
import TrimmedTextUI from "./TrimmedTextUI";

const   Theme1InfoCard3 = ({ setCurrentContentIndex,currentIndex,
  CurrentObject ,
  setCurrentObject, setHideReduUnDo, moveItemUp,moveItemDown,deleteItem,duplicateItem,duplicateContentsItem,item ,dynamicId,
    
}) =>{
   


 const [relativeTop, setRelativeTop] = useState(0);
 const [scrollProgress, setScrollProgress] = useState(0);
 const [isVisible, setIsVisible] = useState(true);
 const [currentVideo, setCurrentVideo] = useState("");
   const [currentI, setCurrentI] = useState(0);
 const [videoPopUp, setVideoPopUp] = useState(false);
               let  myStyles=   {
 circleL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"50%",width:relativeTop? ` ${(scrollProgress*4 )}px `:'',height:relativeTop? ` ${(scrollProgress*4 )}px `:''},
 circleR:{ position:"absolute",left:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"50%",width:relativeTop? ` ${(scrollProgress*4 )}px `:'',height:relativeTop? ` ${(scrollProgress*4 )}px `:''},
 squareL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*2 )}px `:'',height:relativeTop? ` ${(scrollProgress*2 )}px `:''},
 squareR:{ position:"absolute",left:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*2 )}px `:'',height:relativeTop? ` ${(scrollProgress*2 )}px `:''},
 rectangleHR:{ position:"absolute", left:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
 rhombusHR:{ position:"absolute", left:relativeTop? ` ${(scrollProgress*2 )}px `:"",transform:"skewX(40deg)",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
 rectangleHL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*3 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
 rhombusHL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*3 )}px `:"",transform:"skewX(40deg)",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
       
          goUp:{transform:relativeTop? ` translateY(${(relativeTop*3 )}px) `:''},
         goDown:{transform:relativeTop? ` translateY(${(-relativeTop*3 )}px) `:''},
         goLeft:{transform:relativeTop>0? ` translateX(${(relativeTop*3 )}px) `:''},
         goRight:{transform:relativeTop>0? ` translateX(${(-relativeTop*3 )}px) `:''},
        
         zoomIn:{transform:relativeTop? `  scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
        zoomOut:{transform:relativeTop? `  scale(${(relativeTop>1?(relativeTop/100)*1:1 )}) `:''},
       
         skewVertical:{transform:relativeTop>0? ` rotateX(${(relativeTop<90&&relativeTop>0?relativeTop:0  )}deg) skewX(${(relativeTop<30&&relativeTop>0?relativeTop:0 )}deg) `:''},
         skewHorizontal:{transform:relativeTop>0? ` rotateY(${(relativeTop<90&&relativeTop>0?relativeTop:0  )}deg) skewY(${(relativeTop<30&&relativeTop>0?relativeTop:0 )}deg) `:''},
          
         flipVertical:{transform:relativeTop>0? `   rotateX(${(relativeTop<60?-relativeTop:0)}deg) `:''},
          flipHorizontal:{transform:relativeTop>0? `   rotateY(${(relativeTop<60?-relativeTop:0)}deg) `:''},
        spinLeft:{transform:relativeTop>0? `  rotateZ(${(relativeTop )}deg) `:''},
        spinRight:{transform:relativeTop>0? `  rotateZ(${(-relativeTop )}deg) `:''},
       
         slideUpZoom:{transform:relativeTop? ` translateY(${((relativeTop)*3 )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         slideDownZoom:{transform:relativeTop? ` translateY(${((-relativeTop) )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         slideLeftZoom:{transform:relativeTop>0? ` translateX(${(relativeTop*3 )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         slideRightZoom:{transform:relativeTop>0? ` translateX(${(-relativeTop*3 )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         
         slideUpSkew:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  skewX(${((relativeTop<60?relativeTop:0) )}deg) `:''},
        slideDownSkew:{transform:relativeTop>0? `  translateY(${(-relativeTop*3 )}px)  skewX(${((relativeTop<60?-relativeTop:0) )}deg) `:''},
        slideLeftSkew:{transform:relativeTop>0? `  translateX(${(relativeTop*3 )}px)  skewX(${((relativeTop<60?-relativeTop:0) )}deg) `:''},
        slideRightSkew:{transform:relativeTop>0? `  translateX(${(-relativeTop*3 )}px)  skewX(${((relativeTop<60?relativeTop:0) )}deg) `:''},
        
        slideUpRotate:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateZ(${(relativeTop )}deg) `:''},
        slideDownRotate:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateZ(${(-relativeTop )}deg) `:''},
        slideLeftRotate:{transform:relativeTop>0? `  translateX(${(relativeTop*3 )}px)  rotateZ(${((-relativeTop) )}deg) `:''},
        slideRightRotate:{transform:relativeTop>0? `  translateX(${(-relativeTop*3 )}px)  rotateZ(${(relativeTop )}deg) `:''},
       
        slideUpFlip:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateY(${(relativeTop )}deg) `:''},
        slideDownFlip:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateY(${(-relativeTop )}deg) `:''},
        slideLeftFlip:{transform:relativeTop>0? `  translateX(${(relativeTop*3 )}px)  rotateY(${((-relativeTop) )}deg) `:''},
        slideRightFlip:{transform:relativeTop>0? `  translateX(${(-relativeTop*3 )}px)  rotateY(${(relativeTop )}deg) `:''},
       
  
          
        }






 function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }
       const fonts=[
  {name:"AlumniSansSC-Regular",
  fontFamily:"AlumniSansSCRegular , 'Helvetica Neue',sans-serif"
 }
 ,{name:"AlumniSansSC-Italic",
  fontFamily:"AlumniSansSCItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Regular",
  fontFamily:"InterRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Italic",
  fontFamily:"InterItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Lato-Light",
  fontFamily:"LatoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Montserrat-Light",
  fontFamily:"MontserratLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Nunito-Light",
  fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Poppins-Regular",
  fontFamily:"PoppinsRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Light",
  fontFamily:"RalewayLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Thin",
  fontFamily:"RalewayThin , 'Helvetica Neue',sans-serif"
 }

];
  const imagesList1 = [
                   { id: 1,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1747220093883-a5a198dea23a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8NXx8fGVufDB8fHx8fA%3D%3D" },
                 { id: 2,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1688891564708-9b2247085923?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                  { id: 3,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized ScheduleJoin Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689551670902-19b441a6afde?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                { id: 4,hideImage: false, title: "Clear Your DoubtsClear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1664541336896-b3d5f7dec9a3?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                             { id: 5,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689530775582-83b8abdb5020?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                  { id: 6,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                ];
                 const imagesList2 = [
                   { id: 1,hideImage: false, title: "1x1",subtitle: "Live Online Sessions", image: "https://plus.unsplash.com/premium_photo-1747220093883-a5a198dea23a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8NXx8fGVufDB8fHx8fA%3D%3D" },
                 { id: 2,hideImage: false, title: "Personalised",subtitle: "Result-Oriented Curriculum", image: "https://plus.unsplash.com/premium_photo-1688891564708-9b2247085923?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                  { id: 3,hideImage: false, title: "Performance",subtitle: "Opportunities to perform live", image: "https://plus.unsplash.com/premium_photo-1689551670902-19b441a6afde?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                { id: 4,hideImage: false, title: "Graded Syllabus",subtitle: "Join Live Classes With Customized Schedule", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                { id: 5,hideImage: false, title: "Graded Syllabus",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689530775582-83b8abdb5020?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"  },
                            ];
                const titleList1 = [
                   { id: 1,hideImage: false, title: "Only at ClasssMock!",subtitle: "Learn music & dance at your own pace through a personalized adaptive learning model that favors your interest and growth. Get a trusted result-oriented curriculum created by industry experts to accelerate your learning. You will also get multiple performance opportunities to boost your confidence and improve your technical skills.", image: "none" },
                       ];
  const  [cardObjectInn ,setCardObject] =useState(CurrentObject);
  
   const [isHovered, setIsHovered] = useState(false);
const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={`Theme1InfoCard3-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={`Theme1InfoCard3-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={`Theme1InfoCard3-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={`Theme1InfoCard3-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
    </div>
  );
};



const FullWidthCarousel = ({  setCurrentVideo,setVideoPopUp,progressColor,images, itemOuter }) => {
  const containerRef = useRef(null);  const containerRefTwo = useRef(null);
  const [currentI, setCurrentI] = useState(0);
const totalSlides = images.length;
const [progress, setProgress] = useState(0); // from 0 to 100

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentI((prevIndex) => (prevIndex + 1) % totalSlides);
  }, 3000); // Change slide every 3 seconds

  return () => clearInterval(interval); // cleanup on unmount
}, [totalSlides]);
useEffect(() => {
  if(currentI<=totalSlides-1){scrollToSlide(currentI);}else{scrollToSlide(0);}
 
 
}, [currentI]);
  const scroll = (direction) => {
    const container = containerRef?.current;
    const containerTwo = containerRefTwo?.current;
    if (container) {
     
     direction === "left" ?  setCurrentI((prevIndex) => (prevIndex - 1) % totalSlides) : setCurrentI((prevIndex) => (prevIndex + 1) % totalSlides);;
     
    }  if (containerTwo) {
     
     direction === "left" ?  setCurrentI((prevIndex) => (prevIndex - 1) % totalSlides) : setCurrentI((prevIndex) => (prevIndex + 1) % totalSlides);;
     
    }
  };
// Counter logic from 0 to 100 for each slide
useEffect(() => {
  setProgress(0); // reset when currentI changes

  const duration = 3000; // 3 seconds for full counter
  const stepTime = 30;   // update every 30ms
  const increment = 100 / (duration / stepTime); // e.g., ~1 per 30ms

  const counterInterval = setInterval(() => {
    setProgress((prev) => {
      const next = prev + increment;
      if (next >= 100) {
        clearInterval(counterInterval);
        return 100;
      }
      return next;
    });
  }, stepTime);

  return () => clearInterval(counterInterval); // cleanup
}, [currentI]);
  const scrollToSlide = (index) => {
    const container = containerRef?.current;
    if (container) {
      const width = container?.clientWidth;
      container.scrollTo({ left: width * index, behavior: "smooth" });
    
    } const containerTwo = containerRefTwo?.current;
    if (containerTwo) {
      const width = container?.clientWidth;
      containerTwo?.scrollTo({ left: width * index, behavior: "smooth" });
    
    }
  };

  return (<>
  
    
      <div className={`Theme1InfoCard3-cardRight-${itemOuter?.myKey}`} 
        //   onClick={()=>{setCurrentObject(itemOuter?.myKey,itemOuter);setCurrentContentIndex(parseInt(itemOuter?.contentNo)); }}
         style={{
  ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item3Animation?.type:""],
  
}} >
    
     <div className={`carousel-wrapper-${itemOuter?.myKey}`}>
      <div className={`carousel-container-${itemOuter?.myKey}`} ref={containerRefTwo}>
        {images.map((itemInner, index) => (
          <div className={`carousel-slide-${itemOuter?.myKey}`} key={index}>
            
            
            {!itemInner?.hideImage && (
              <div
                style={{
                  position: "relative",
                  top: "0px",
                  left: "0px",
                  right: "0px",
                  zIndex: "99",
                }}
              >

                <div style={{position:"relative",top:"50px",zIndex:"999"}}>
             <div style={{ ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item1Animation?.type:""],
           padding:"10px 25px",
              border:`5px solid #333333`,background:`${progressColor?.color10}`,
              borderTopLeftRadius:itemOuter?.layoutSettings?.borderRadius1?.topLeft?.value+itemOuter?.layoutSettings?.borderRadius1?.topLeft?.resolution,borderBottomLeftRadius:itemOuter?.layoutSettings?.borderRadius1?.bottomLeft?.value+itemOuter?.layoutSettings?.borderRadius1?.bottomLeft?.resolution,borderTopRightRadius:itemOuter?.layoutSettings?.borderRadius1?.topRight?.value+itemOuter?.layoutSettings?.borderRadius1?.topRight?.resolution,borderBottomRightRadius:itemOuter?.layoutSettings?.borderRadius1?.bottomRight?.value+itemOuter?.layoutSettings?.borderRadius1?.bottomRight?.resolution}}> <div className={`Theme1InfoCard3-cardRight-title-${itemOuter?.myKey}  ${itemOuter?.layoutSettings?.titleEllipsis?.status?`Theme1InfoCard3-cardRight-title-ellipsis-${itemOuter?.myKey}`:``}`} 
              style={{
             
  
    fontSize: `${itemOuter?.layoutSettings?.typographyTitle?.size?.value}${itemOuter?.layoutSettings?.typographyTitle?.size?.resolution}`,
    fontFamily: `${itemOuter?.layoutSettings?.typographyTitle?.family?.fontFamily}`,
    fontWeight: `${itemOuter?.layoutSettings?.typographyTitle?.weight?.fontWeight}`,
    textAlign: `${itemOuter?.layoutSettings?.typographyTitle?.textAlignment?.textAlign}`,
    textTransform: `${itemOuter?.layoutSettings?.typographyTitle?.textCase?.textTransform}`,
    fontStyle: `${itemOuter?.layoutSettings?.typographyTitle?.textStyle?.textStyle}`,
   textDecoration: `${itemOuter?.layoutSettings?.typographyTitle?.decoration?.line}  ${itemOuter?.layoutSettings?.typographyTitle?.decoration?.style} ${itemOuter?.layoutSettings?.typographyTitle?.decoration?.decorationColor?.color} ${itemOuter?.layoutSettings?.typographyTitle?.decoration?.thickness?.value}${itemOuter?.layoutSettings?.typographyTitle?.decoration?.thickness?.resolution}`,
      lineHeight: `${itemOuter?.layoutSettings?.typographyTitle?.lineHeight?.value}${itemOuter?.layoutSettings?.typographyTitle?.lineHeight?.resolution}`,
   letterSpacing: ` ${itemOuter?.layoutSettings?.typographyTitle?.letterSpacing?.value}${itemOuter?.layoutSettings?.typographyTitle?.letterSpacing?.resolution}`,
    wordSpacing: ` ${itemOuter?.layoutSettings?.typographyTitle?.wordSpacing?.value}${itemOuter?.layoutSettings?.typographyTitle?.wordSpacing?.resolution}`,
    
    WebkitTextStroke: `${itemOuter?.layoutSettings?.typographyTitle?.textStroke?.strokeSize?.value}px ${itemOuter?.layoutSettings?.typographyTitle?.textStroke?.strokeColor?.color}`,
   
     }}
       
          > {<TrimmedTextUI text={itemInner?.title} />}</div> </div> 

          <div className={`Theme1InfoCard3-cardRight-description-${itemOuter?.myKey} 
            ${itemOuter?.layoutSettings.subtitleEllipsis?.status?`Theme1InfoCard3-cardRight-description-ellipsis-${itemOuter?.myKey}`:``}`}
              style={{ ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item2Animation?.type:""],
 padding:"5px 25px",marginTop:"20px",
    fontSize: `${itemOuter?.layoutSettings?.typographySubtitle?.size?.value}${itemOuter?.layoutSettings?.typographySubtitle?.size?.resolution}`,
    fontFamily: `${itemOuter?.layoutSettings?.typographySubtitle?.family?.fontFamily}`,
    fontWeight: `${itemOuter?.layoutSettings?.typographySubtitle?.weight?.fontWeight}`,
    textAlign: `${itemOuter?.layoutSettings?.typographySubtitle?.textAlignment?.textAlign}`,
    textTransform:`${itemOuter?.layoutSettings?.typographySubtitle?.textCase?.textTransform}`,
    fontStyle: `${itemOuter?.layoutSettings?.typographySubtitle?.textStyle?.textStyle}`,
    textDecoration: `${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.line}  ${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.style} ${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.decorationColor?.color} ${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.thickness?.value}${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.thickness?.resolution}`,
    lineHeight: ` ${itemOuter?.layoutSettings?.typographySubtitle?.lineHeight?.value}${itemOuter?.layoutSettings?.typographySubtitle?.lineHeight?.resolution}`,
    letterSpacing: ` ${itemOuter?.layoutSettings?.typographySubtitle?.letterSpacing?.value}${itemOuter?.layoutSettings?.typographySubtitle?.letterSpacing?.resolution}`,
    wordSpacing: ` ${itemOuter?.layoutSettings?.typographySubtitle?.wordSpacing?.value}${itemOuter?.layoutSettings?.typographySubtitle?.wordSpacing?.resolution}`,
    WebkitTextStroke: ` ${itemOuter?.layoutSettings?.typographySubtitle?.textStroke?.strokeSize?.value}${itemOuter?.layoutSettings?.typographySubtitle?.textStroke?.strokeSize?.resolution}  ${itemOuter?.layoutSettings?.typographySubtitle?.textStroke?.strokeColor?.color}`,
              }}
          
          > {<TrimmedTextUI text={itemInner?.subtitle} />}</div> 

                </div>
                
                
              </div>
            )}
          </div>
        ))}
         <div className={`carousel-dots-${itemOuter?.myKey}`} style={{...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item5Animation?.type:""],}}>
 

  {images
    .slice(
      Math.max(0, currentI - 1),
      Math.min(images?.length, currentI + 3)
    )
    .map((itemInner, i) => {
      const realIndex = Math.max(0, currentI - 1) + i;
      return (
        <div
          key={realIndex}
          className={`dot-${itemOuter?.myKey} ${currentI === realIndex ? "" : ""}`}
          onClick={() => setCurrentI(realIndex)} 
          style={{ background:currentI === realIndex
                  ? `${itemOuter?.layoutSettings?.item2BG?.color}`
                  : "",}}
        >
          {currentI === realIndex?<div
            className={`squarebox-Theme1InfoCard3-${itemOuter?.myKey}`}
            style={{  
                left:currentI === realIndex
                  ? `${progress}%`
                  : "", }}>

 <div
            className={`circle-Theme1InfoCard3-${itemOuter?.myKey}`}
            style={{  borderTopLeftRadius:itemOuter?.layoutSettings?.borderRadius3?.topLeft?.value+itemOuter?.layoutSettings?.borderRadius3?.topLeft?.resolution,borderBottomLeftRadius:itemOuter?.layoutSettings?.borderRadius3?.bottomLeft?.value+itemOuter?.layoutSettings?.borderRadius3?.bottomLeft?.resolution,borderTopRightRadius:itemOuter?.layoutSettings?.borderRadius3?.topRight?.value+itemOuter?.layoutSettings?.borderRadius3?.topRight?.resolution,borderBottomRightRadius:itemOuter?.layoutSettings?.borderRadius3?.bottomRight?.value+itemOuter?.layoutSettings?.borderRadius3?.bottomRight?.resolution,            background:
                currentI === realIndex
                  ? `conic-gradient(${progressColor?.color10} 0% ${progress}%, black 0% 80%, transparent 80% 100%)`
                  : "",
            }}
          >
            <div className={`circlekInn-Theme1InfoCard3-${itemOuter?.myKey}`}>
              <ImageFallFB
                itemOuter={itemOuter}
                boxShadow={`${itemOuter?.layoutSettings?.item1Shadow?.horizontal?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.vertical?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.blur?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.spread?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.shadowColor?.color} ${itemOuter?.layoutSettings?.item1Shadow?.inset ? "inset" : ""}`}
                src={itemInner.image}
                border={`${itemOuter?.layoutSettings?.item1Border?.borderWidth?.value}px ${itemOuter?.layoutSettings?.item1Border?.borderType} ${itemOuter?.layoutSettings?.item1Border?.borderColor?.color}`}
                width={
                  itemOuter?.layoutSettings.item1Width?.value
                    ? itemOuter?.layoutSettings.layoutWidth?.value
                    : 100
                }
                aspectRatio={1 / 1}
                borderRadius={
                  itemOuter?.layoutSettings?.borderRadius3 || {
                    value: 50,
                    resolution: "%",
                  }
                }
              />
            </div>
          </div>

                  </div>:""}
        </div>
      );
    })}
</div>

        {/* Buttons */}
        
      </div>


     
    </div> </div>
    <div className={`Theme1InfoCard3-cardImages-${itemOuter?.myKey}`} style={{
  ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.layoutAnimation?.type:""],
  transition: `transform 0.1s ease-in-out, opacity 0.5s ease`,
}}>    
     
    <div className={`carousel-wrapper-${itemOuter?.myKey}`}><div className={`carousel-SlideNo-${itemOuter?.myKey}`} style={{...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item3Animation?.type:""],background:`${itemOuter?.layoutSettings?.item2BG?.color}`}}>
  <h3><span style={{fontSize:"40px", fontFamily: `${itemOuter?.layoutSettings?.typographySubtitle?.family?.fontFamily}`,}}>{currentI+1}</span>/{totalSlides}</h3>
</div>
      <div className={`carousel-container-${itemOuter?.myKey}`} ref={containerRef}>
        <div className={`carousel-container-pagenation-${itemOuter?.myKey}`}>
            <button className={`carousel-btn-${itemOuter?.myKey} left`} onClick={() => setCurrentI((prevIndex) => (prevIndex>0?prevIndex - 1:prevIndex) % totalSlides)}>
              <ChevronLeft  size={30} color={"#333"} strokeWidth={1} />
            </button>
            <button className={`carousel-btn-${itemOuter?.myKey} right`} onClick={() => setCurrentI((prevIndex) => (prevIndex + 1) % totalSlides)}>
              <ChevronRight size={30} color={"#333"}  strokeWidth={1} />
            </button>
          </div>
        {images.map((itemInner, index) => (
          <div className={`carousel-slide-${itemOuter?.myKey} `} key={index}>
            

            {!itemInner?.hideImage && (
              <div
                style={{
                  position: "relative",
                  top: "0px",
                  left: "0px",
                  right: "0px",
                  zIndex: "99",
                }}
              >
<div style={{display:"flex",justifyContent:"center",}}>
      <div onClick={()=>{setCurrentVideo(itemInner?.video);setVideoPopUp(true) 
      }}   className={`playButtonOuter-Theme1InfoCard3-${itemOuter?.myKey}`} style={{...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item6Animation?.type:""],position:"absolute", alignItems:"center",cursor:"pointer"}} > 
      <div className={`playButtonInner-${itemOuter?.myKey}`} ></div>
       <Play strokeWidth={3}  size={45} style={{margin:"4px",marginLeft:"50px"}}  color="#fff"/>
          </div></div>
                 <div style={{...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item4Animation?.type:""],}}>
                <ImageFallFB  itemOuter={itemOuter}
                  boxShadow={`${itemOuter?.layoutSettings?.item1Shadow?.horizontal?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.vertical?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.blur?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.spread?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.shadowColor?.color} ${itemOuter?.layoutSettings?.item1Shadow?.inset ? "inset" : ""}`}
                  src={itemInner.image}
                  border={`${itemOuter?.layoutSettings?.item1Border?.borderWidth?.value}px ${itemOuter?.layoutSettings?.item1Border?.borderType} ${itemOuter?.layoutSettings?.item1Border?.borderColor?.color}`}
                  width={
                    itemOuter?.layoutSettings.item1Width?.value
                      ? itemOuter?.layoutSettings.layoutWidth?.value
                      : 100
                  }
                  aspectRatio={
                    itemOuter?.layoutSettings.item1AspectRatio?.value
                      ? itemOuter?.layoutSettings.item1AspectRatio?.value
                      : 1
                  }
                  borderRadius={
                    itemOuter?.layoutSettings?.borderRadius1 || {
                      value: 30,
                      resolution: "%",
                    }
                  }
                /></div>
              </div>
            )}
          </div>
        ))}

        {/* Buttons */}
        
      </div>


      {/* Dots */}
     
    </div></div>
    </>
  );
};





return(<>
{}
  <ScrollTransformWrapper 
  setRelativeTop={(relativeTop)=>{setRelativeTop(relativeTop)}}
  setIsVisible={(isVisible)=>{setIsVisible(isVisible)}}
  setScrollProgress={(scrollProgress)=>{setScrollProgress(scrollProgress)}}
  containerId="scrollContainerId"
        maxTranslate={100}
        maxRotate={0}
        maxScale={1.1}
        customStyleFn={({ scale }) => ({
          myStyles:myStyles,
          transition: "transform 0.2s ease-in-out",
        })}
      >
        
       {videoPopUp?<>
       <div     style={{zIndex:99,cursor:"pointer"}} onClick={()=>setVideoPopUp(false)} className={`videoPlayerPopUpBackDrop-${CurrentObject?.contents[1]?.myKey}`}> </div>
        <div   className={`videoPlayerPopUpMain-${CurrentObject?.contents[1]?.myKey}`} style={{height:"400px",borderRadius: '20px'}}> 
  <div style={{position:"relative"}}>
    <div  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",right:"0px",margin:"10px",position:"absolute",
      background:`${CurrentObject?.contents[1]?.layoutSettings?.item1BG?.color}`,zIndex:99999999999999}} onClick={()=>{setVideoPopUp(false)}}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div>
    </div> 
       {currentVideo?.sourceType=="youtube"?<YoutubeVideoPlayerWebUI  videoSettings={currentVideo} videoId={currentVideo?.youtube?.src} minHeight={400} maxHeight={400}/>:""}
      
 </div>
       </>:""}
<div   className="hoverItemElementInner" onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)} 
      style={{
position:"relative",border:dynamicId==CurrentObject?.myKey?"2px solid rgba(144, 202, 249,1)":isHovered?"2px solid rgba(144, 202, 249,1)":"2px solid transparent",
          margin:"0px",marginTop:"25px",overflow:"hidden"}} >{}
           
     
                    <div className={isHovered?"":""} onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}  style={{height:"30px",width:"100%",position:"absolute",top:"-5px",left:"0px",}}>
       {dynamicId==CurrentObject?.contents[0]?.myKey? <div   style={{position:"absolute",top:"-12px",left:"0px",fontSize:"12px",width:"73px",height:"25px",borderRadius:"5px"}}> <div style={{position:"absolute",top:"0px",left:"0px",right:"0px",bottom:"0px"}}><div className="ElementSettingsItem"  style={{display:"flex",justifyContent:"space-between",position:"absolute",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"60px",height:"15px",paddingRight:"5px",}}> <CheckCheck size={12}  color="#333" /> Selected</div></div></div>:
        
          ""}  
    
       
        {isHovered? <div onClick={()=>{
          // setCurrentObject(CurrentObject?.contents[0]?.myKey,CurrentObject?.contents[0]);setCurrentContentIndex(CurrentObject?.contents[0]?.contentNo)
        }} className={isHovered?"":""}
            style={{position:"absolute",top:"-9px",width:"27px",height:"28px",}}> <div style={{position:"absolute",top:"1px",left:"0px",right:"0px",bottom:"0px"}}> <div className="ElementSettingsItem"   style={{display:"flex",justifyContent:"space-between",position:"absolute",fontSize:"12px",padding:"3px",left:"-1px"}}> <Pencil size={18}  color="#333" /></div></div> </div>:""}
    </div>
      <div className={`Theme1InfoCard3-card-${CurrentObject?.contents[1]?.myKey}`}>
      <div  className={`Theme1InfoCard3-card-BG${CurrentObject?.contents[1]?.myKey}`} ></div>
     
      
         {CurrentObject?.contents.map((itemOuter,indexOuter)=>(<>
      
       {indexOuter==1?<>
      
        
      
<FullWidthCarousel setVideoPopUp={(videoPopUp)=>{setVideoPopUp(videoPopUp)}}
setCurrentISend={(currentI)=>{setCurrentI((prevIndex) => currentI)}}
 setCurrentVideo={(currentVideo)=>{setCurrentVideo(currentVideo)}}
  progressColor={CurrentObject?.contents[1]?.layoutSettings?.item1BG?.colors} images={itemOuter?.itemCards?.cards}  itemOuter={itemOuter} />
      
        
     

        
        </>:""}</>))}
        
     
     
      </div> </div></ScrollTransformWrapper>
      
      <style>{ CurrentObject?.contents?.map((item,index)=>(`
      .videoPlayerPopUpBackDrop-${item?.myKey}{position:fixed;top:0px;
        left:0px;
        right:0px;
       
        bottom:0px;
        padding:15px;
        background:rgba(1, 1, 1,0.661);
        z-index:99999999 !important}
        .videoPlayerPopUpMain-${item?.myKey}{position:fixed;top:0px;
    left:20%;
    right:20%;
    background: linear-gradient(to right, #fff,#f5f5f5, #fff, #fff);
    top:15%;
    padding:15px;
    z-index:99999999 !important;}
.carousel-dots-${item?.myKey} {padding:10px;margin:10px; 
  border-top-left-radius:${item?.layoutSettings?.borderRadius3?.topLeft?.value+"px"};
    border-bottom-left-radius:${item?.layoutSettings?.borderRadius3?.bottomLeft?.value+"px"};
    border-top-right-radius:${item?.layoutSettings?.borderRadius3?.topRight?.value+"px"};
    border-bottom-right-radius:${item?.layoutSettings?.borderRadius3?.bottomRight?.value+"px"};
 
 
  text-align: center;width:100%;position:absolute;right:0px !important;bottom:-30px;z-index:999!important;
  margin-top: 10px;
}
  
.carousel-SlideNo-${item?.myKey} {padding:10px;margin:10px; border-radius:15px;
  text-align: center;width:50px;position:absolute;left:43% ;top:-60px;z-index:999!important;
  margin-top: 10px;
}
  
.circle-Theme1InfoCard3-${item?.myKey} {
    width: 130px;
    height: 130px;
    border-radius: 50%;
   
    display: flex;
    align-items: center;
    justify-content: center;
    position:relative;
  }
  .circlekInn-Theme1InfoCard3-${item?.myKey} {
    position:absolute;
     height: 120px;
  width: 120px;
    border-radius: 50%;
    ;z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
    
  }
    .circle-Theme1InfoCard3.activek {
    background-color: rgb(86, 82, 131) ;
   
    border: 2px solid rgb(86, 82, 131);
    border-radius: 50%;
  
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  }
.squarebox-Theme1InfoCard3-${item?.myKey} {
   
   
    display: flex;
    align-items: center;
    justify-content: center;
    position:absolute;top:10px;;
  }
.dot-${item?.myKey} {
  display: inline-block;
  height: 60px;
  width: 60px;
  margin: 5px 10px;
 
  border-radius: 50%;
  cursor: pointer;background: #333;
  transition: background 0.3s;
}


    .carousel-wrapper-${item?.myKey} {
  position: relative;
  
  width: 100%;
}

.carousel-btn-${item?.myKey} {
  position: absolute;display:flex;justify-content:center;align-items:center;
  top: 35%; height:50px;width:50px;
 margin: 3px;border:2px solid #ffffffff;
       box-shadow:0 7px 20px 0 rgba(1,1,1,0.0501);border-radius: 5px;background: #ffffff;
  
  cursor: pointer;
  z-index: 999999;
}

.carousel-btn-${item?.myKey}.left {
  left: 10px;
}

.carousel-btn-${item?.myKey}.right {
  right: 10px;
}
.carousel-container-${item?.myKey} {
  display: flex;height:400px;
  overflow-x: auto; overflow-y:hidden !important;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  width: 100%;
}

.carousel-container-${item?.myKey}::-webkit-scrollbar {
  display: none;
}

.carousel-slide-${item?.myKey} {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
}

.carousel-slide-${item?.myKey} img {
  width: 100%;
  height: auto;
  display: block;
}


.playButtonOuter-Theme1InfoCard3-${item?.myKey}{
 position: absolute;transform:scale(0.7);
    border:7px solid rgba(256, 256, 256, 0.50302); // Optional background for visibility
    color: white;z-index:999 !important;bottom:30% !important;
    padding: 18px;background:${item?.layoutSettings?.item2BG?.color};
    border-top-left-radius:${item?.layoutSettings?.borderRadius2?.topLeft?.value+"px"};
    border-bottom-left-radius:${item?.layoutSettings?.borderRadius2?.bottomLeft?.value+"px"};
    border-top-right-radius:${item?.layoutSettings?.borderRadius2?.topRight?.value+"px"};
    border-bottom-right-radius:${item?.layoutSettings?.borderRadius2?.bottomRight?.value+"px"};
    width: 150px; // Adjust as needed
    height: 150px;
      }
.playButtonInner-${item?.myKey}{animation: PlayButtonAnim 2.8s infinite linear;
  border:7px solid rgba(256, 256, 256, 0.50302);
  z-index:999 !important;
  position: absolute;top:3px;left:50px;right:0px;bottom: 0px;
  padding: 18px;
   border-top-left-radius:${item?.layoutSettings?.borderRadius2?.topLeft?.value+"px"};
    border-bottom-left-radius:${item?.layoutSettings?.borderRadius2?.bottomLeft?.value+"px"};
    border-top-right-radius:${item?.layoutSettings?.borderRadius2?.topRight?.value+"px"};
    border-bottom-right-radius:${item?.layoutSettings?.borderRadius2?.bottomRight?.value+"px"};
   
  width: 35px; 
  height: 35px;}
@keyframes PlayButtonAnim{
  0% {
      /* opacity: 0; */
      transform: scale(1.4)
  }
  50% {
      transform: scale(0.81)
  }
 
  100% {
      transform: scale(1.4)
  }
  }
        .Theme1InfoCard3-card-${item?.myKey} {
          
           width:${item?.layoutSettings?.layoutWidth?.value}%;
          display: ${"flex"};
         flex-direction:${item?.layoutSettings?.flexDirection};
         flex-wrap:${item?.layoutSettings?.flexWrap};
          
          justify-content:${item?.layoutSettings?.justifyContent};
         align-items:${item?.layoutSettings?.alignItems};
          gap:  ${item?.layoutSettings?.gap}px;
          
          justify-content:${item?.layoutSettings?.justifyContent};
         align-items:${item?.layoutSettings?.alignItems};
          gap:  ${item?.layoutSettings?.gap}px;
         
         border-radius:${item?.layoutSettings?.borderRadius1?.value}${item?.layoutSettings?.borderRadius1?.resolution};
         box-shadow:${item?.layoutSettings?.layoutShadow?.horizontal?.value}px ${item?.layoutSettings?.layoutShadow?.vertical?.value}px ${item?.layoutSettings?.layoutShadow?.blur?.value}px ${item?.layoutSettings?.layoutShadow?.spread?.value}px ${item?.layoutSettings?.layoutShadow?.shadowColor?.color} ${item?.layoutSettings?.layoutShadow?.inset?"inset":""};

     
          
        }
          .Theme1InfoCard3-card-BG${item?.myKey} {
           position:absolute;right:0px;bottom:0px;top:0px;
           width:30%;
        
         background:${item?.layoutSettings?.layoutBG?.color};
       
        }
          

          .Theme1InfoCard3-card-${item?.myKey}:hover {
         
         
         
        }
          .Theme1InfoCard3-cardImages-${item?.myKey} {
         
          
       border-radius:${item?.layoutSettings?.borderRadius1?.value}${item?.layoutSettings?.borderRadius1?.resolution};
           width:${item?.layoutSettings?.layoutWidth?.value}%;
          
 margin-top:${item?.layoutSettings?.margin?.marginTop?.value}${item?.layoutSettings?.margin?.marginTop?.resolution};
            margin-bottom:${item?.layoutSettings?.margin?.marginBottom?.value}${item?.layoutSettings?.margin?.marginBottom?.resolution};
           
        }
  .Theme1InfoCard3-cardImages-${item?.myKey} {
          margin:10px; position:relative;
          
       border-radius:${item?.layoutSettings?.borderRadius1?.value}${item?.layoutSettings?.borderRadius1?.resolution};
           width:${item?.layoutSettings?.item1Width?.value}%;
          
 margin-top:${item?.layoutSettings?.margin?.marginTop?.value}${item?.layoutSettings?.margin?.marginTop?.resolution};
            margin-bottom:${item?.layoutSettings?.margin?.marginBottom?.value}${item?.layoutSettings?.margin?.marginBottom?.resolution};
            margin-left:${item?.layoutSettings?.margin?.marginLeft?.value}${item?.layoutSettings?.margin?.marginLeft?.resolution};
            margin-right:${item?.layoutSettings?.margin?.marginRight?.value}${item?.layoutSettings?.margin?.marginRight?.resolution};
          
        }
 
.Theme1InfoCard3-cardRight-${item?.myKey} {
           position:relative;
           
           width:${item?.layoutSettings?.item2Width?.value}%;
          
          gap: ${item?.layoutSettings?.gap}px;
          
          border-radius:${item?.layoutSettings?.borderRadius1?.value}${item?.layoutSettings?.borderRadius1?.resolution};
         
          padding:10px;
           margin-top:${item?.layoutSettings?.marginItem2?.marginTop?.value}${item?.layoutSettings?.marginItem2?.marginTop?.resolution};
            margin-bottom:${item?.layoutSettings?.marginItem2?.marginBottom?.value}${item?.layoutSettings?.marginItem2?.marginBottom?.resolution};
            margin-left:${item?.layoutSettings?.marginItem2?.marginLeft?.value}${item?.layoutSettings?.marginItem2?.marginLeft?.resolution};
            margin-right:${item?.layoutSettings?.marginItem2?.marginRight?.value}${item?.layoutSettings?.marginItem2?.marginRight?.resolution};
           padding-top:${item?.layoutSettings?.padding?.paddingTop?.value}${item?.layoutSettings?.padding?.paddingTop?.resolution};
            padding-bottom:${item?.layoutSettings?.padding?.paddingBottom?.value}${item?.layoutSettings?.padding?.paddingBottom?.resolution};
            padding-left:${item?.layoutSettings?.padding?.paddingLeft?.value}${item?.layoutSettings?.padding?.paddingLeft?.resolution};
            padding-right:${item?.layoutSettings?.padding?.paddingRight?.value}${item?.layoutSettings?.padding?.paddingRight?.resolution};
            border:${item?.layoutSettings?.layoutBorder?.borderWidth?.value}px ${item?.layoutSettings?.layoutBorder?.borderType} ${item?.layoutSettings?.layoutBorder?.borderColor?.color};
          
        }

.Theme1InfoCard3-CardImage-wrapper${item?.myKey} {

position:absolute;z-index:99!important
width:95px;height:95px;
   
}
  
       
         
.Theme1InfoCard3-cardRight-title-${item?.myKey} {
        z-index:999;
        background: ${item?.layoutSettings?.typographyTitle?.titleColor?.color};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  background-clip: text;
  color: transparent;
          width:${item?.layoutSettings.layoutWidth?.value?item?.layoutSettings.layoutWidth?.value:70}%;
          
     white-space: ${item?.layoutSettings.titleEllipsis?.status?"nowrap":"none"};
    overflow:  ${item?.layoutSettings.titleEllipsis?.status?"hidden":"none"};
    text-overflow: ${item?.layoutSettings.titleEllipsis?.status?"ellipsis":"none"} ;;

   
        }

        .Theme1InfoCard3-cardRight-description-${item?.myKey} {
          font-size: 0.85rem;position:relative;z-index:999;
           background: ${item?.layoutSettings?.typographySubtitle?.titleColor?.color};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  background-clip: text;
  color: transparent;
          width:${item?.layoutSettings.layoutWidth?.value?item?.layoutSettings.layoutWidth?.value-10:70}%;
          
     white-space: ${item?.layoutSettings.subtitleEllipsis?.status?"nowrap":"none"};
    overflow:  ${item?.layoutSettings.subtitleEllipsis?.status?"hidden":"none"};
    text-overflow: ${item?.layoutSettings.subtitleEllipsis?.status?"ellipsis":"none"} ;;
   }
           .Theme1InfoCard3-cardRight-description-ellipsis-${item?.myKey} {
         white-space: nowrap;
    overflow:  hidden;
    text-overflow: ellipsis
      } .Theme1InfoCard3-cardRight-title-ellipsis-${item?.myKey} {
        
           white-space: nowrap;
    overflow:  hidden;
    text-overflow: ellipsis
      }

/* md */
@media (min-width: 992px) and (max-width: 1199px) {
 .playButtonOuter-Theme1InfoCard3-${item?.myKey}{
 bottom:-100px !important;transform:scale(0.7)
    
      }
  .videoPlayerPopUpMain-${item?.myKey}{position:fixed;top:0px;
                left:10%;
                right:10%;top:100px;
               } 
 }
/* sm */
@media (min-width: 768px) and (max-width: 991px) {
.Theme1InfoCard3-card-${item?.myKey} { flex-direction:column;}
  .Theme1InfoCard3-cardImages-${item?.myKey} { width:100%;margin:0px}
  .carousel-dots-${item?.myKey} { width:320px; bottom:0px; transform:scale(0.7)}
   .playButtonOuter-Theme1InfoCard3-${item?.myKey}{
 bottom:-100px !important;transform:scale(0.7)
    
      }
  .videoPlayerPopUpMain-${item?.myKey}{position:fixed;
                left:10%;
                right:10%;top:100px;
               } 
  }
                                   /* xs */
@media (max-width: 767px) {
 .Theme1InfoCard3-card-${item?.myKey} { flex-direction:column; margin-bottom:0px !important}

 .Theme1InfoCard3-cardRight-${item?.myKey} {width:100% !important;margin:0px !important;}
 
  .Theme1InfoCard3-cardImages-${item?.myKey} { width:100%;margin:0px !important}
    .Theme1InfoCard3-CardImage-AspectRatioXs${item?.myKey} { aspect-ratio:1/1 !important;}
    .Theme1InfoCard3-cardRight-title-${item?.myKey} {line-height:30px  !important; ; ;top:32px,left:0px !important;right:0px !important;}
  .Theme1InfoCard3-cardRight-description-${item?.myKey} { font-size: 0.7rem !important;;width:100%;top:8px;}
  .Theme1InfoCard3-cardRight-title-${item?.myKey} {font-size: 1.4rem  !important; ;}
  .Theme1InfoCard3-card-BG${item?.myKey} {height:300px; }
  .carousel-dots-${item?.myKey} { width:320px; bottom:-20px; transform:scale(0.7)}

  .carousel-SlideNo-${item?.myKey} { border-radius:15px;transform:scale(0.7);
  left:75% !important;
}
  .playButtonOuter-Theme1InfoCard3-${item?.myKey}{
 bottom:70px !important;transform:scale(0.7);
    
      }
  .videoPlayerPopUpMain-${item?.myKey}{position:fixed;top:0px;
                left:0%;
                right:0%;top:0px; bottom:0px!important;
               } 
}
 
      `))}</style>
  
</>)
}
export default Theme1InfoCard3;